import { render, staticRenderFns } from "./ArticlesPreview.vue?vue&type=template&id=087fa041"
import script from "./ArticlesPreview.vue?vue&type=script&lang=js"
export * from "./ArticlesPreview.vue?vue&type=script&lang=js"
import style0 from "./ArticlesPreview.vue?vue&type=style&index=0&id=087fa041&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports